import React from "react";
import Card from "@mui/material/Card";
import Footer from "../../../components/Footer";
import MDBox from "../../../components/MDBox";
import DashboardNavbar from "../../../components/Navbars/DashboardNavbar";
import DashboardLayout from "../../../components/LayoutContainers/DashboardLayout";
import DataTable from "../../../components/DataTable/DataTable";
import {API_URL, COLOR_SECONDARY} from "../../../config";
import useSales from "./useSales";
import {NavLink} from "react-router-dom";
import {renderCurrency} from "../../../helpers/helpers";
import moment from "moment";
import DateFilter from "../../../components/DateFilter/DateFilter";

const Sales = () => {
    const {actions, userId, renderStatusChip } = useSales();

    return (
        <DashboardLayout>
            <DashboardNavbar/>
            <MDBox pt={2} pb={3}>
                <MDBox mb={3}>
                    <Card>
                        <DataTable
                            endpoint={`${API_URL}/sales/doctor/${userId}`}
                            title="Ventas"
                            description="Visualizar las ventas registradas."
                            sortBy="id"
                            sortDirection="desc"
                            filter={true}
                            actions={actions}
                            colData={[
                                {
                                    name: 'id',
                                    label: 'Folio',
                                    options: {
                                        display: 'excluded'
                                    }
                                },
                                {
                                    name: 'created_at',
                                    label: 'Fecha',
                                    options: {
                                        customBodyRender: (value, tableMeta, updateValue) => (
                                            <NavLink to={`/ventas/${tableMeta.rowData[0]}`}
                                                     key={`venta-${tableMeta.rowData[0]}`}
                                                     style={{fontWeight: 500, color: COLOR_SECONDARY, textDecoration: 'underline'}}
                                            >
                                                {value}
                                            </NavLink>
                                        ),
                                        filterType: 'custom',
                                        customFilterListOptions: {
                                            render: v => {
                                                if (v[0] && v[1]) return `Fecha: ${moment(v[0]).format('YYYY-MM-DD')} - ${moment(v[1]).format('YYYY-MM-DD')}`;
                                                if (v[0]) return `Desde: ${moment(v[0]).format('YYYY-MM-DD')}`;
                                                if (v[1]) return `Hasta: ${moment(v[1]).format('YYYY-MM-DD')}`;
                                                return false;
                                            },
                                            update: (filterList, filterPos, index) => {
                                                if (filterPos === 0) filterList[index].splice(filterPos, 1, '');
                                                else filterList[index] = [];
                                                return filterList;
                                            }
                                        },
                                        filterOptions: {
                                            names: [],
                                            display: (filterList, onChange, index, column) => <DateFilter filterList={filterList} column={column} onChange={onChange} index={index} />
                                        }
                                    }
                                },
                                {
                                    name: 'patient.name',
                                    label: 'Paciente',
                                    options: {
                                        customBodyRender: (value, tableMeta, updateValue) => (
                                            <div>
                                                {value} {tableMeta.rowData[2]} {tableMeta.rowData[3]}
                                            </div>
                                        )
                                    }
                                },
                                {
                                    name: 'patient.last_name',
                                    label: 'Apellido',
                                    options: {
                                        display: 'excluded'
                                    }
                                },
                                {
                                    name: 'patient.mother_last_name',
                                    label: 'Apellido Materno',
                                    options: {
                                        display: 'excluded'
                                    }
                                },
                                {
                                    name: 'location.display_name',
                                    label: 'Sucursal'
                                },
                                {
                                    name: 'doctor_fee',
                                    label: 'Comisión',
                                    options: {
                                        customBodyRender: renderCurrency,
                                        filter: false
                                    }
                                },
                                {
                                    name: 'status',
                                    label: 'Estado',
                                    options: {
                                        customBodyRender: (value, tableMeta, updateValue) => {
                                            return renderStatusChip(value)
                                        }
                                    }
                                }
                            ]}
                        />
                    </Card>
                </MDBox>
            </MDBox>
            <Footer />
        </DashboardLayout>
    );
};

export default Sales;
